var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYaGptLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    color: "var(--color-primary)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 6,
    cx: 8,
    cy: 8
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "850ms",
    begin: "0s",
    fill: "freeze",
    repeatCount: "indefinite",
    path: "M 0 0 a 1 3 145 0 1 8 8 a 1 3 145 0 1 -8 -8"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    dur: "850ms",
    values: "6; 2.3; 6",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.3,
    cx: 16,
    cy: 16
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "850ms",
    begin: "0s",
    fill: "freeze",
    repeatCount: "indefinite",
    path: "M 0 0 a 1.2 2.7 157 0 1 -5 -6.7 a 1.2 2.7 157 0 1 5 6.7"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    dur: "850ms",
    values: "2.3; 6; 2.3",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYaGptLoading);
export default __webpack_public_path__ + "static/media/yaGPTLoading.93ea9842ee3bf4472bfb5dd4d439d8a5.svg";
export { ForwardRef as ReactComponent };